import React from 'react'
import NumbersTwilioSelectNewNumberStep from 'features/Numbers/NumbersTwilioSelectNewNumberStep'
import NumbersSummaryStep from 'features/Numbers/NumbersSummaryStep'
import BillingAccountLinkStep from 'features/Billing/BillingAccountLinkStep'
import LoginOrRegister from 'features/Auth/LoginOrRegister'
import NumbersCommonForm from '../NumbersForm/NumbersCommonForm'
import UploadDocumentsStep from '../NumbersTwilioUploadDocumentsStep'
import DefaultFlowsConfigStep from '../NumbersTwilioDefaultFlowsConfigStep'
import http from 'axios'

export default class NumbersTwilioForm extends NumbersCommonForm {
  constructor(props) {
    super(props)

    const isLoggedIn = props.isLoggedIn

    this.state.steps = [
      ...(isLoggedIn
        ? []
        : [
            {
              wrapInForm: false,
              Component: () => <LoginOrRegister afterSubmit={this.submit} />,
            },
          ]),
      {
        wrapInForm: true,
        Component: props => <NumbersTwilioSelectNewNumberStep prev={props.onCancel} {...props} />,
      },
      ...(props.numberType === 'local' || props.numberType === 'mobile'
        ? [
            {
              wrapInForm: true,
              Component: props => <DefaultFlowsConfigStep prev={this.prevStep} {...props} />,
            },
          ]
        : []),
      {
        wrapInForm: true,
        Component: props => <BillingAccountLinkStep prev={this.prevStep} {...props} />,
        isBillingAccountStep: true,
      },
      {
        wrapInForm: true,
        Component: props => <NumbersSummaryStep prev={this.prevStep} {...props} />,
      },
    ]

    this.submit = this.submit.bind(this)
  }

  submit(formData) {
    if (!this.shouldWeCheckForApprovedBundle()) {
      super.submit(formData)
      return
    }

    const { change } = this.props
    change('isLoading', true)

    http({
      method: 'GET',
      url: `api/v1/twilio/${formData.ban}/has-approved-bundle`,
    }).then(response => {
      if (response.data.hasApprovedBundle) {
        this.removeUploadStep()
      } else {
        this.insertUploadStep()
      }

      change('isLoading', false)
      super.submit(formData)
    })
  }

  shouldWeCheckForApprovedBundle = () => {
    const { numberType } = this.props
    const { steps, step } = this.state

    return numberType === 'mobile' && steps[step].isBillingAccountStep
  }

  insertUploadStep = () => {
    if (this.hasUploadStep()) {
      return
    }

    const { steps, step } = this.state
    const index = step + 1
    const uploadStep = {
      wrapInForm: true,
      Component: props => <UploadDocumentsStep prev={this.prevStep} {...props} />,
      isUploadStep: true,
    }

    this.setState({
      steps: [].concat(steps.slice(0, index), [uploadStep], steps.slice(index)),
    })
  }

  removeUploadStep = () => {
    if (!this.hasUploadStep()) {
      return
    }

    const { steps } = this.state

    this.setState({
      steps: steps.filter(step => !step.isUploadStep),
    })
  }

  hasUploadStep = () => {
    const { steps } = this.state
    return steps.filter(step => step.isUploadStep).length > 0
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersTwilioForm/NumbersTwilioForm.jsx